/* eslint-disable react/no-array-index-key */
import PropTypes from 'prop-types';
import DOMPurify from 'dompurify';
import '../downloadRcm.scss';

export function SystemRequirements({ data }) {
  return (
    <div>
      <div className='systemRequirementsContainer'>
        <div className='systemBlock'>
          <p className='systemTitle'>{data.windows.title}</p>

          {data.windows.items.map((item) => (
            <div key={item.label} className='systemRow'>
              <p className='systemLabel'>
                {item.label}
              </p>

              {Array.isArray(item.value) ? (
                <div className='systemValue'>
                  {item.value.map((v, i) => (
                    <p key={i}>{v}</p>
                  ))}
                </div>
              ) : (
                <p className='systemValue'>{item.value}</p>
              )}
            </div>
          ))}
        </div>

        <div className='systemBlock'>
          <p className='systemTitle'>{data.macos.title}</p>

          {data.macos.items.map((item) => (
            <div key={item.label} className='systemRow'>
              <p className='systemLabel'>
                {item.label}
              </p>

              {Array.isArray(item.value) ? (
                <div className='systemValue'>
                  {item.value.map((v, i) => (
                    <p key={i}>{v}</p>
                  ))}
                </div>
              ) : (
                <p className='systemValue'>{item.value}</p>
              )}
            </div>
          ))}
        </div>
      </div>

      <div className='systemNotes'>
        {data.notes?.map((note, i) => (
          <div
            key={i}
            className='note'
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(note) }}
          />
        ))}
      </div>
    </div>
  );
}

const requirementItem = PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]).isRequired,
});

const systemSection = PropTypes.shape({
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(requirementItem).isRequired,
});

SystemRequirements.propTypes = {
  data: PropTypes.shape({
    windows: systemSection.isRequired,
    macos: systemSection.isRequired,
    notes: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
};
